import React from 'react'

import debounce from 'debounce'

import {
    Table,
    Input
} from 'antd'

/**
 * @property {array} columns - columns defining what gets shownu
 * @property {function} request - axios request to fetch data,
 * must follow @function { searchParam, page, pageSize } => ({ data, total })
 * 
 * @property {number} [pageSize]
 * @property {boolean} [noLoadOnMount] - should data load once component is mounted?
 * @property {string} [defaultValue] - default search value
 */
class GenericSearchTable extends React.Component {
    
    state = {
        data: [],

        page: 1,
        pageSize: this.props.pageSize || 50,
        searchParam: this.props.defaultValue || '',
        total: 0,
        
        loading: false
    }

    render(){

        const { 
            data,
        
            page,
            pageSize,
            total,

            loading
        } = this.state

        return (
            <span>
                {!this.props.hideSearch && 
                <Input 
                    defaultValue={this.props.defaultValue}
                    placeholder={this.props.placeholder || 'Search...'}
                    style={{ marginBottom: 16 }}
                    onChange={this.handleSearch}
                />}
                <Table  
                    columns={this.props.columns}
                    loading={loading}
                    dataSource={data}
                    pagination={{
                        pageSize,
                        current: page,
                        total,
                        nextPage: (nextPage) => this.setState({ page: nextPage }, this.getData)
                    }}
                />
            </span>
        )
    }

    constructor(props){
        super(props)

        this.setSearch = debounce(this.setSearch, 400)
    }

    componentDidMount(){
        if( !this.props.noLoadOnMount ){
            this.getData()
        }
    }
    
    getData = () => {

        this.setState({ loading: true })

        const {
            page,
            pageSize,
            searchParam,
        } = this.state

        this.props.request({
            page,
            pageSize,
            searchParam
        })
        .then( res => {

            const {
                data,
                total
            } = res.data

            this.setState({ data, total, loading: false  })
            
        })

    }

    handleSearch = (e) => {
        
        const searchParam = e.target.value

        this.setSearch(searchParam)
        
    }

    setSearch = (searchParam) => {
        this.setState({
            searchParam
        }, this.getData)
    }
}

export default GenericSearchTable


// WEBPACK FOOTER //
// ./src/components/generics/search-table.js